import {React, Component} from 'react'
import {BrowserRouter as Router, Link} from "react-router-dom";
import ReactModal from 'react-modal'
import './Tile.css';


class Tile extends Component {
  constructor(props){
    super(props)
    this.state = {
        showModal: false,
        label_counts: [],
        notes: [],
        all_labels :  ['upsidedown', 'horns', 'hat', 'food', 'transformer', 'comet', 'spaceship', 'triangle', 'bird','smiley','zombie', 'cyclops', 'shape', 'heart','circle', 'square', 'animal', 'alien', 'ape', 'bear', 'bull', 'cat', 'creature', 'crab', 'dog', 'frog', 'ghost', 'human', 'mouse', 'panda', 'robot', 'abstract', 'dark', 'holes', 'minimal', 'light', 'lowContrast', 'highContrast', 'xSymmetrical','twoTone', 'object', 'helmet', 'mask', 'skull', 'invader',  'tool', 'emoji',  'idk', 'face','eyes', 'mouth', 'ears','nose', 'bug','blob','slime','fox','plant','flower','bunny','android','jellyfish','mammal','reptile','skeleton','ogre'],

    }

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);

  }

  handleOpenModal () {
    this.setState({ showModal: true });
  }
  
  handleCloseModal () {
    this.setState({ showModal: false });
  }


  componentDidMount(){
    const labels = this.state.all_labels.filter(label=>this.props.element[label])
      const label_counts = labels.map(label=>{
          return(
              {"label":label, "count": this.props.element[label]}
      )})
      const notes = this.props.element["other"].split(",")

      this.setState({label_counts:label_counts, notes: notes})
  }

  render(){

    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          fontFamily: 'VT323',
          textAlign: 'center',
          overflowY: 'scroll',
          maxHeight: '600px',
          maxWidth: '1000px',
          '-webkit-scrollbar' : {display: 'none'},
          scrollbarWidth: 'none',
        },
      };

      


    return (

      <div className="Tile">
  
                    <div  style={{textDecoration:"none", color:"black"}} onClick={this.handleOpenModal}>
                        <div style={{borderRadius:"5px", padding:"10px"}} className="result">
                        <div  style={{margin:"10px", }} >
                            <div style={{width:"220px"}}>
                            <img style={{ width:"100%", borderRadius:"5px"}} src={this.props.element["image"]}/>
                            </div>
                            <div style={{ width:"220px"}}>
                            <span style={{fontSize: "12px", color:"grey", margin:"0px 5px 0px 0px"}}>{this.props.element["id"]}</span>
                            <span>{this.props.element["name"]}</span>
                            <span><a style={{ margin:"0px 0px 0px 5px", fontSize:20, textDecoration:"none"}} target="_blank" className="open-sea-link" href={this.props.element["link"]}>⤯</a></span>
                            </div>
                        
                        </div>
                        </div>
                    </div>
                    <ReactModal isOpen={this.state.showModal} contentLabel="onRequestClose Example" onRequestClose={this.handleCloseModal} style={customStyles} >
                        <div onClick={this.handleCloseModal}>
                        
                        <div style={{fontSize:"65px", margin:"20px 0px 0px 0px", fontWeight:"900", letterSpacing:"3px"}}>
                            {this.props.element["name"]} 
                            {/* <a style={{margin:"0px 0px -20px -20px", fontSize:34}} className="open-sea-link" href={this.state.glyphOpenSeaLink}>⤯</a> */}
                        </div>
                            <div className="cols" style={{margin:"20px", display: "flex", flexWrap:"wrap", flex:"1"}}>
                                <div style={{margin:"20px", marginBottom:"0px", width:"45%",  minWidth:"200px"}}>
                                        <img src={this.props.element["image"]} style={{ width:"80%", borderRadius:"5px"}}/>
                                </div>
                                <div style={{fontSize:"20px", margin:"20px", marginBottom:"0px", width:"45%", minWidth:"350px"}}>
                                    <div style={{fontWeight:"900", fontSize:"35px"}}>votes:</div>
                                    <div>
                                        {this.state.label_counts.map(element=><div style={{margin:"5px"}}>{element["count"]} {element["label"]}</div>)}    
                                    </div>  
                                    <div style={{marginTop:"20px", fontWeight:"900",fontSize:"35px"}}>notes:</div>
                                    <div>
                                        {this.state.notes.map(element=><div style={{margin:"5px"}}>{element}</div>)}    
                                    </div>    
                                
                                </div>
                        
                            </div>
                        </div>
                    </ReactModal>


      </div>
                              
    
    );
  
  }
}

export default Tile;
